import script from "./sjInfoAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./sjInfoAdd.vue?vue&type=script&setup=true&lang=js"

import "./sjInfoAdd.vue?vue&type=style&index=0&id=07a9ad2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a9ad2a"]])

export default __exports__